var STEP_ADDRESS = 2;
var STEP_IMPACT_SELECT = 3;
var STEP_IMPACT_INFOS = 4;
var STEP_VISUALIZE = 5;

(function ($, Promise) {

    // Constructor
    function VICCVisualizeBreadcrumb() {
      // console.log("VICCVisualizeBreadcrumb: constructor()");

      this.trottledScrollFunction = throttle(this.onScroll.bind(this), 200, true);
      this.breadcrumbStatus = false;

      this.breadcrumbVisualizeTl = gsap.timeline();
    }

    VICCVisualizeBreadcrumb.prototype.attach = function (dom) {
      // console.log("VICCVisualizeBreadcrumb: attach()");

      this.setStatus(STATUS_WAITING);

      // Init Triggers
      this.initTrigger();

      $(window).on('scroll', this.trottledScrollFunction);
      $(window).on("resize", $.proxy(this.resize, this));
    }

    /*
     * Init Triggers
     */
    VICCVisualizeBreadcrumb.prototype.initTrigger = function () {

      // Scroll to section
      $("#visualize-breadcrumb").on("click", ".breadcrumb-item", $.proxy(function (e) {
        var scrollTargetId = $(e.currentTarget).data("target");
        var scrollTarget = $("#" + scrollTargetId);

        if (app.currentComponent instanceof VICCVisualize) {
          // Close breadcrumb on small devices
          if (window.viewport().width < 1000) {
            $("#visualize-breadcrumb.shown #breadcrumb-mobile-trigger").trigger("click");
          }

          if (scrollTarget.length > 0) {
            VICC.prototype.scrollTo(scrollTarget);
          }
        } else {
          barba.go("/" + app.language + "/visualize");
        }
      }, this));

      // Select another disaster
      $("#visualize-breadcrumb").on("click", "#breadcrumb-disaster-selector li", $.proxy(function (e) {
        var disaster = $(e.currentTarget).data("disaster");

        // Animate icon only when selection is a different disaster
        if (!$(e.currentTarget).is(".current")) {
          $("#visualize-breadcrumb .breadcrumb-item").eq(4).removeClass("animate");
          setTimeout(function () {
            $("#visualize-breadcrumb .breadcrumb-item").eq(4).addClass("animate");
          }, 10);
        }

        // Trigger disaster change
        $(this).trigger("selectDisaster", disaster);
      }, this));

      // Open map overlay, process another address
      $("#visualize-breadcrumb").on("click", "#breadcrumb-try-another-address", $.proxy(function (e) {
        $(this).trigger("tryAnotherAddress");
      }, this));

      // Open breacrumbs menu on small devices
      $("#visualize-breadcrumb").on("click", "#breadcrumb-mobile-trigger", function () {

        // Bypass inView transition
        $("#visualize-breadcrumb").removeAttr("style");

        if ($("#visualize-breadcrumb").is(".shown")) {
          $("#visualize-breadcrumb").removeClass("shown");
        } else {
          $("#visualize-breadcrumb").addClass("shown");
        }
      });
    }

    /*
     * On scroll callback (throttled)
     */
    VICCVisualizeBreadcrumb.prototype.onScroll = function () {

      if ($("#main").attr("data-barba-namespace") === "share") {
        return;
      }

      // Update breadcrumbs on scroll o show disaster selector
      if (this.breadcrumbStatus >= STEP_IMPACT_SELECT && this.step >= STEP_IMPACT_INFOS) {

        var resultPosition = $('#visualize-result').offset().top - $(window).scrollTop();

        if (resultPosition < ($("#header").outerHeight() + 1) && this.breadcrumbStatus >= STATUS_READY) {
          this.setStatus(STATUS_VISUALIZE);
          this.setStep(STEP_VISUALIZE);
        } else {
          this.setStatus(STATUS_READY);
          this.setStep(STEP_IMPACT_INFOS);
        }
      }

      var offset = $("#header").outerHeight() + 20;
      var bottomCalculation = $(window).scrollTop() + $(window).height() == $(document).height();

      // Highlight menu item based on scroll position
      $("#visualize-breadcrumb .breadcrumb-item[data-target]").each(function () {
        var anchor = "#" + $(this).attr('data-target');
        var targetY = $(anchor)[0].getBoundingClientRect().y - offset;

        if (bottomCalculation) {
          // When user scroll at the bottom
          $("#visualize-breadcrumb .breadcrumb-item[data-target]").removeClass("active");
          $("#visualize-breadcrumb .breadcrumb-item:not(.disabled)").last().addClass("active");
        } else if (targetY <= 0) {
          $("#visualize-breadcrumb .breadcrumb-item[data-target]").removeClass("active")
          $(this).addClass("active");
        } else {
          // none
          $(this).removeClass("active");
        }
      });

      // Show thumbnail when scrolling past the map
      if ($("#disaster-selector-infos")[0].getBoundingClientRect().bottom - $("#header").outerHeight() <= 0) {
        $("#breadcrumb-try-another-address").removeClass("hidden");

        // show thumbnail
        this.breadcrumbVisualizeTl.to("#breadcrumb-try-another-address", 0.5, {
          height: $("#breadcrumb-try-another-address .breadcrumb-try-another-address-inner").outerHeight()
        });
      } else {
        $("#breadcrumb-try-another-address").addClass("hidden");

        this.breadcrumbVisualizeTl.clear();

        // hide thumbnail
        this.breadcrumbVisualizeTl.to("#breadcrumb-try-another-address", 0.5, {
          height: 0,
        });
      }

      // Close breadcrumb on small devices
      if (window.viewport().width < 1000) {
        $("#visualize-breadcrumb.shown #breadcrumb-mobile-trigger").trigger("click");
      }
    }

    VICCVisualizeBreadcrumb.prototype.setStatus = function (status) {
      this.breadcrumbStatus = status;

      $("#visualize-breadcrumb .breadcrumb-item-status").addClass("hidden");
      $("#visualize-breadcrumb .breadcrumb-item").eq(4).removeClass("animate");

      if (status == STATUS_WAITING) {
        $("#visualize-breadcrumb #breadcrumb-item-status-waiting").removeClass("hidden");
      } else if (status == STATUS_READY) {
        $("#visualize-breadcrumb #breadcrumb-item-status-ready").removeClass("hidden");
      } else if (status == STATUS_VISUALIZE) {
        $("#visualize-breadcrumb #breadcrumb-item-status-selector").removeClass("hidden");

        // get user attention by using an animation
        $("#visualize-breadcrumb .breadcrumb-item").eq(4).addClass("animate");
      }
    }

    VICCVisualizeBreadcrumb.prototype.setStep = function (step) {

      if (step == STEP_ADDRESS) {
        $("#visualize-breadcrumb .breadcrumb-item").eq(2).addClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(3).addClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(4).addClass("disabled");

      } else if (step == STEP_IMPACT_SELECT) {
        $("#visualize-breadcrumb .breadcrumb-item").eq(2).removeClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(3).addClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(4).addClass("disabled");

      } else if (step == STEP_IMPACT_INFOS || step == STEP_VISUALIZE) {
        $("#visualize-breadcrumb .breadcrumb-item").eq(2).removeClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(3).removeClass("disabled");
        $("#visualize-breadcrumb .breadcrumb-item").eq(4).removeClass("disabled");
      }

      if (step == STEP_VISUALIZE) {

        $("#breadcrumb-disaster-selector").removeClass("hidden");

        if (this.step != step) {

          this.breadcrumbVisualizeTl.clear();

          // show disaster selector
          this.breadcrumbVisualizeTl.to("#breadcrumb-disaster-selector", 0.5, {
            height: 112,
          }).to("#breadcrumb-disaster-selector", 0.5, {
            alpha: 1,
          });
        }
      } else {
        if (this.step != step) {

          $("#breadcrumb-disaster-selector").addClass("hidden");

          this.breadcrumbVisualizeTl.clear();

          // hide disaster selector
          this.breadcrumbVisualizeTl.to("#breadcrumb-disaster-selector", 0.5, {
            alpha: 0,
          }, "-=0.5").to("#breadcrumb-disaster-selector", 0.5, {
            height: 0
          });
        }
      }

      this.step = step;
    }

    VICCVisualizeBreadcrumb.prototype.setDisaster = function (selectedDisaster) {
      $("#visualize-breadcrumb li[data-disaster='flood'], #visualize-share li[data-disaster='flood']").toggleClass("current", (selectedDisaster == "flood"));
      $("#visualize-breadcrumb li[data-disaster='wildfire'], #visualize-share li[data-disaster='wildfire']").toggleClass("current", (selectedDisaster == "wildfire"));
      $("#visualize-breadcrumb li[data-disaster='smog'], #visualize-share li[data-disaster='smog']").toggleClass("current", (selectedDisaster == "smog"));
    }

    VICCVisualizeBreadcrumb.prototype.resize = function () {
      // Recalculate sections height
      $("#breadcrumb-try-another-address:not(.hidden)").height($("#breadcrumb-try-another-address .breadcrumb-try-another-address-inner").outerHeight());
    }

    VICCVisualizeBreadcrumb.prototype.dettach = function () {
      // console.log("VICCVisualizeBreadcrumb: dettach()");

      // reset variables
      this.setStatus(STATUS_WAITING);
      this.breadcrumbStatus = false;
      this.breadcrumbVisualizeTl.kill();

      $(window).off('scroll', this.trottledScrollFunction);
      $(window).off("resize", $.proxy(this.resize, this));
    }

    // Expose VICCVisualizeBreadcrumb
    window.VICCVisualizeBreadcrumb = VICCVisualizeBreadcrumb;

  }
)
(jQuery, Promise);
